import { useMemo } from "react";
import { Form } from "antd";
import { useVenueContext } from "contexts/VenueContext";
import { useDiscountCodeCreateMutation } from "@ticketingplatform/api/dist/discountCode";
import useApolloErrorFields from "hooks/useApolloErrorFields";
import { DiscountCodeFormProps } from "views/DiscountCodes/DiscountCodeCreate/partials/DiscountCodeForm/types";

import { discountCodeFormLayout } from "./consts";
import { UseDiscountCodeForm } from "./types";

export const useDiscountCodeForm: UseDiscountCodeForm = ({ onFinish }) => {
  const [form] = Form.useForm();
  const { venue } = useVenueContext();
  const [discountCodeCreateMutation, { loading, error }] =
    useDiscountCodeCreateMutation();
  const fields = useApolloErrorFields(error);

  return useMemo<DiscountCodeFormProps>(
    () => ({
      ...discountCodeFormLayout,
      form,
      loading,
      fields,
      items: { events: { hidden: true, preserve: false } },
      async onFinish({
        input: {
          name,
          code,
          amount,
          maxUse,
          expireAt,
          numberOfTicketsAppliedInOrder,
        },
      }) {
        const { data } = await discountCodeCreateMutation({
          variables: {
            input: {
              name,
              code,
              amount,
              maxUse,
              expireAt,
              numberOfTicketsAppliedInOrder,
              isApplicableToAllEvents: false,
              venueId: venue?.id,
            },
          },
        });

        const { discountCodeCreate: discountCode } = data || {};

        if (!discountCode) {
          return;
        }

        onFinish?.({ discountCode });
      },
    }),
    [discountCodeCreateMutation, fields, form, loading, onFinish, venue?.id]
  );
};
